import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';

// Market-specific block: same layout on every country version, different content.
export default function MarketFocus({ market }) {
  return (
    <section id="market" className="relative py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="text-center mb-14">
          <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-4 block">{market.eyebrow}</span>
          <h2 className="font-inter font-black text-4xl md:text-5xl tracking-[-0.03em] text-foreground mb-4">{market.title}</h2>
          <div className="w-16 h-px bg-primary/40 mx-auto" />
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="space-y-4">
            {market.paras.map((p, i) => <p key={i} className="text-muted-foreground font-inter leading-relaxed">{p}</p>)}
          </div>
          <div className="rounded-2xl border border-border/50 bg-card/50 backdrop-blur-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <ShieldCheck className="w-5 h-5 text-primary" />
              <h3 className="font-inter font-bold text-lg text-foreground">{market.complianceTitle}</h3>
            </div>
            {market.complianceParas.map((p, i) => <p key={i} className="text-sm text-muted-foreground font-inter leading-relaxed mb-4">{p}</p>)}
            <ul className="space-y-3">
              {market.bullets.map((b) => (
                <li key={b} className="flex gap-3 text-sm text-muted-foreground font-inter leading-relaxed">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0" aria-hidden="true" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <h3 className="font-inter font-bold text-2xl text-foreground mb-6 text-center">{market.sectorsTitle}</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {market.sectors.map((s) => (
            <div key={s.title} className="rounded-2xl border border-border/50 bg-card/50 backdrop-blur-sm p-6 hover:border-primary/30 transition-colors duration-500">
              <h4 className="font-inter font-bold text-foreground mb-2">{s.title}</h4>
              <p className="text-sm text-muted-foreground font-inter leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}